export const CURRENT_RELEASE = {
  version: '3.5.13',
  date: '2026. 10. 16.',
  title: '안드로이드 APK를 내려받아 설치하세요',
  description: '설치 페이지에서 Family Album 안드로이드 앱 파일을 내려받아 가족에게 전달할 수 있어요.',
  changes: [
    { icon: 'ri-android-fill', title: '안드로이드 APK 다운로드', description: '앱 파일을 받아 설치하면 홈 화면에서 Family Album을 열 수 있어요.' },
    { icon: 'ri-download-2-line', title: '안드로이드 설치 버튼', description: '설치를 지원하는 브라우저에서는 설치 버튼으로 시작하고, 그 외에는 메뉴에서 추가하는 방법을 안내해요.' },
    { icon: 'ri-share-forward-line', title: '가족에게 설치 링크 공유', description: '설치 링크를 복사하거나 공유 메뉴로 가족에게 보낼 수 있어요. 사진은 로그인한 가족에게만 보여요.' },
  ],
} as const;

export function getUpdateNoticeStorageKey(userId: string | number) {
  return `bongnas-family:update-notice:${CURRENT_RELEASE.version}:user-${userId}`;
}
